import React from "react";
import { BookingRules, BookingType } from "api/bookings";
import { Club } from "api/clubs";
import { NumberPicker } from "components";
import i18n from "../i18n";

// prop types
interface DurationPickerProps {
    bookingRules: BookingRules,
    club?: Club | null,
    disabled?: boolean,
    duration: number,
    error?: string | null,
    type?: BookingType,
    onChange: (duration: number) => void,
}

// duration picker form element
const DurationPicker = ({ bookingRules, club, disabled, duration, error, type, onChange }: DurationPickerProps) => {
    // relevant errors
    const relevantErrors = ["bookingTooLong"];
    const getHelperText = () => {
        if (type !== BookingType.Standard) return "";
        return i18n.durationHint(bookingRules.personalContingentMins, club?.comingUpBookingMins);
    };

    // render
    return (
        <NumberPicker
            disabled={disabled}
            error={relevantErrors.includes(error!)}
            helperText={getHelperText()}
            label={i18n.duration}
            max={(type === BookingType.Standard) ? bookingRules?.personalContingentMins : undefined}
            min={bookingRules?.minDurationMins}
            step={15}
            value={duration}
            onChange={onChange}
        />
    );
};

export default DurationPicker;
